module.exports = __webpack_public_path__ + "static/media/better_way_left.4306daf0.png";